"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var PortalSettingsKeys = {
  ACTIVITY_TYPES_ENABLED: 'engagements:ActivityTypes:Enabled',
  ADMIN_OPTED_PORTAL_INTO_REDESIGN: 'BetaToggle:AdminOptedPortalIn',
  ATMENTION_USER_INVITE_MAP: 'Onboarding:atmention_user_invite_map',
  COMPANY_CONTACT_ASSOCIATOR: 'companies:contact:associator',
  CONTACTS_PUBLIC_VIEW: 'contacts:public_profile:access',
  CURRENCY_TYPE: 'contacts:currency_type',
  GDPR_COMPLIANCE_ENABLED: 'GDPRComplianceEnabled',
  LIFECYLCLE_COMPANY_SYNC: 'deals::sync_contact_lifecyclestage',
  LIFECYLCLE_CONTACT_SYNC: 'deals::sync_company_lifecyclestage',
  PORTAL_HAS_ACTIVATION: 'Onboarding:PortalHasActivation',
  PROPAGATE_OWNER: 'companies:propagate-owner',
  RECORDING_SETTINGS_KEY: 'Integrations:Twilio:RecordingEnabled',
  SFDC_V2_ENABLED: 'sfdc:v2-enabled',
  VIEWED_DEAL_SETTINGS: 'deals:settings:viewedDealSettings'
};
var _default = PortalSettingsKeys;
exports.default = _default;
module.exports = exports.default;